unit GA.Return.Types;

interface



uses System.Generics.Collections  {$IFDEF PAS2JS},JS{$ENDIF};


//{$IFDEF PAS2JS}

//uses
//  JS, System.Generics.Collections;
//{$ENDIF}

type

  TTenantIdAndName = class
  public
    Id: Integer;
    TenantId: string;
    Name: string;
    Status: string;
  end;

  TGiftAigOrgConfig = class
    Id: Integer;
    TenantId: string;
    /// <summary>
    ///   Only used when a Charity client is managed my an Agent
    /// </summary>
    AgentId: Integer;
    OrganisationKind: String;
    Depth: Integer;
    RefId: string;
    Name: string;
    Status: string;
    LicenseType: string;
    LicenseExpires: TDate;
    AuthUserCount: Integer;
  end;

  TGiftAidOrgData = class(TGiftAigOrgConfig)
    LegalName: string;
    Add1: string;
    Add2: string;
    Add3: string;
    Add4: string;
    Add5: string;
    PostCode: string;
    Country: string;
  end;

  TGAUser = class
    InternalId: Integer;
    // Sphinx App Values - read from JWT?
    OrganisationId: Integer;
//    OrganisationName: string;
    TenantId: string;
    JobTitle: string;
    JobPosition: string;
    Title: string;
    GivenName: string;
    LastName: string;
    Email: string;
    EmailConfirmed: Boolean;
    PhoneNumber: string;

    UserStatus: string; // TUserStatus;
    UserScope: string; // TUserScope;

    function Initials: string;
    function IsAdmin: Boolean;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); virtual;
{$ENDIF}
  end;

  TGiftAidUser = class(TGAUser)
    // Local App Values
    HMRCPhone: string;
    HMRCPostCode: string;
    HMRCRegistered: Boolean;
    CanPrepareClaims: Boolean;
    OrganisationSource: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject); override;
{$ENDIF}

  end;

  TUserCounts = class
    Licensed: Integer;
    Active: Integer;
    Inactive: Integer;
    Archived: Integer;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
    function AvailableSeats: Integer;
  end;

  TTenantCounts = class
    Licensed: Integer;
    Active: Integer;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
    function IsUnlimited: Boolean;
    function AvailableTenants: Integer;
  end;

  TAgentCharity = class
    OrganisationId: Integer;
    OrganisationName: string;
    TenantId: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TOrganisationConfiguration = class
    ClearDownSubmission: boolean;
    NoMatching: boolean;
    SaveHMRCPassword: boolean;
    /// <summary>True once the HMRC config prompt has been shown for this tenant (first-login prompt). Stored in DB.</summary>
    HMRCPromptShown: boolean;
    /// <summary>
    /// Max total Gift Aid (GBP) allowed in a prepared claim (sum across included donations).
    /// Stored on CHARITY.DEFAULT_MAX_CLAIM_AMOUNT in the tenant database.
    /// Used only when smxi.ini ClaimMaxAmount is not set. 0 or blank clears CHARITY.DEFAULT_MAX_CLAIM_AMOUNT (NULL).
    /// </summary>
    MaxClaimAmount: Double;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  /// <summary>
  /// Server-side claim Gift Aid limit settings from smxi.ini and CHARITY.
  /// </summary>
  TClaimMaxAmountSettings = class
    Enabled: Boolean;
    /// <summary>smxi.ini ClaimMaxAmount. When &gt; 0, charity config is display-only.</summary>
    ServerAmount: Double;
    /// <summary>CHARITY.DEFAULT_MAX_CLAIM_AMOUNT for the current tenant.</summary>
    CharityAmount: Double;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  /// <summary>
  /// Result of portal claim-declaration persistence (sign / revoke / mark used).
  /// Mirrors CLAIM_DECLARATION fields needed by the Review → Sign → Submit UI.
  /// </summary>
  TClaimDeclarationPersistResult = class
    Success: Boolean;
    DeclarationId: Integer;
    ClaimId: Integer;
    DeclarationStatus: string;
    SignedByUser: Integer;
    SignedByName: string;
    SigningChannel: string;
    SignedAt: TDateTime;
    ExpiresAt: TDateTime;
    Message: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TPrepareClaimData = class
    Complete: boolean;
    ClaimId: integer;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;
    /// <summary>True when the selection exceeds the prepare-job claim limit.</summary>
    LimitExceeded: boolean;
    MaxClaimCount: integer;
    MaxClaimAmount: currency;
    IncludedDonationCount: integer;
    IncludedAmount: currency;
    IncludedGiftAid: currency;
    RemainingDonationCount: integer;
    RemainingAmount: currency;
    RemainingGiftAid: currency;
    /// <summary>
    /// Donation-only Gift Aid for the eligible selection (GiftAidValue basis).
    /// Excludes GASDS, adjustments and other claim types. EligibleGiftAid - RemainingGiftAid = IncludedGiftAid.
    /// </summary>
    EligibleGiftAid: currency;
    /// <summary>
    /// True when eligible donations exist but none fit under the Gift Aid amount limit.
    /// Not a partial claim — nothing will be prepared.
    /// </summary>
    NothingFitsLimit: boolean;

{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TClaimParameters = class
    Complete: boolean;
    OldestDate: string;
    NewestDate: string;
    ImportIds: string;
    ImportFiles: string;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  TRetrievePreparedClaim = class
    Exists: boolean;
    PrepareJobId: integer;
    ClaimId: integer;
    OldestDate: string;
    NewestDate: string;
    ImportId: string;
    ClaimRef: string;
    DonationCount: integer;
    Amount: currency;
    GiftAid: currency;
    GASDS: currency;
    AggregatedDonations: currency;
    OtherIncome: currency;
    GASDSAdjustments: currency;
    Adjustments: currency;
    CommunityBuildings: currency;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

  /// <summary>
  /// Open / WaitingAuth claim that Submit Claim should resume (e.g. after Sign
  /// created a claim shell before Authorise & Submit).
  /// </summary>
  TResumableClaimInfo = class
    Exists: Boolean;
    ClaimId: Integer;
    ClaimRef: string;
    ClaimStatus: string;
    DeclarationSigned: Boolean;
    DeclarationExpiresAt: TDateTime;
{$IFDEF PAS2JS}
    procedure Assign(Source: JS.TJSObject);
{$ENDIF}
  end;

const
  /// <summary>Config version that introduced HMRCPromptShown. Clients pass this when calling GetOrganisationConfiguration so the server returns the key; older/rolled-back clients omit it and get config without the key.</summary>
  ORGANISATION_CONFIG_VERSION_WITH_HMRC_PROMPT_SHOWN = 2;

  GATenantLimitExceededMessage =
    'This agent has reached the maximum number of client organisations.';

  GATenantLimitUserMessage =
    'You have reached your charity limit. Please contact your administrator if you need to add more charities.';


implementation

uses
  System.SysUtils,
  System.Math,
  SMX.Auth.Shared;

{ TGiftAidUser }

{$IFDEF PAS2JS}

procedure TGAUser.Assign(Source: JS.TJSObject);
begin
  InternalId := Integer(Source.Properties['InternalId']);
  OrganisationId := Integer(Source.Properties['OrganisationId']);
//  OrganisationName := string(Source.Properties['OrganisationName']);
  TenantId := string(Source.Properties['TenantId']);
  JobTitle := string(Source.Properties['JobTitle']);
  JobPosition := string(Source.Properties['JobPosition']);
  Title := string(Source.Properties['Title']);
  GivenName := string(Source.Properties['GivenName']);
  LastName := string(Source.Properties['LastName']);
  Email := string(Source.Properties['Email']);
  EmailConfirmed := Boolean(Source.Properties['EmailConfirmed']);
  UserStatus := string(Source.Properties['UserStatus']);
  UserScope := string(Source.Properties['UserScope']);
  PhoneNumber := string(Source.Properties['PhoneNumber']);
end;
{$ENDIF}

function TGAUser.Initials: string;
begin
  result := '';
  if not GivenName.IsEmpty then
    result := GivenName.Substring(0, 1).ToUpper;
  if not LastName.IsEmpty then
    result := result + LastName.Substring(0, 1).ToUpper;
  result := result.TrimRight;
end;

function TGAUser.IsAdmin: Boolean;
begin
  result := (UserScope = SCOPE_ADMIN) or (UserScope = SCOPE_SUPERUSER) or
    SameText(UserScope, 'AdminManager') or SameText(UserScope, 'Administrator');
end;

{$IFDEF PAS2JS}

procedure TGiftAidUser.Assign(Source: JS.TJSObject);
begin
  inherited;
  HMRCPhone := string(Source.Properties['HMRCPhone']);
  HMRCPostCode := string(Source.Properties['HMRCPostCode']);
  HMRCRegistered := Boolean(Source.Properties['HMRCRegistered']);
  { Prefer CanPrepareClaims; accept legacy CanSubmit from older payloads.
    Default false when neither key is present — never treat missing as true. }
  if Source.hasOwnProperty('CanPrepareClaims') then
    CanPrepareClaims := JS.toBoolean(Source['CanPrepareClaims'])
  else if Source.hasOwnProperty('CanSubmit') then
    CanPrepareClaims := JS.toBoolean(Source['CanSubmit'])
  else
    CanPrepareClaims := False;
  if Source.hasOwnProperty('OrganisationSource') then
    OrganisationSource := string(Source.Properties['OrganisationSource'])
  else
    OrganisationSource := '';
end;
{$ENDIF}


{ TUserCounts }

function TUserCounts.AvailableSeats: Integer;
begin
  result := Licensed - Active;
end;

{ TTenantCounts }

function TTenantCounts.IsUnlimited: Boolean;
begin
  Result := Licensed <= 0;
end;

function TTenantCounts.AvailableTenants: Integer;
begin
  if IsUnlimited then
    Result := -1
  else
    Result := Max(0, Licensed - Active);
end;

{$IFDEF PAS2JS}

procedure TTenantCounts.Assign(Source: JS.TJSObject);
begin
  Licensed := Integer(Source['Licensed']);
  Active := Integer(Source['Active']);
end;

procedure TUserCounts.Assign(Source: JS.TJSObject);
begin
  Licensed := Integer(Source['Licensed']);
  Active := Integer(Source['Active']);
  Inactive := Integer(Source['Inactive']);
  Archived := Integer(Source['Archived']);
end;

procedure TAgentCharity.Assign(Source: JS.TJSObject);
begin
  OrganisationId := Integer(Source['OrganisationId']);
  OrganisationName := string(Source['OrganisationName']);
  TenantId := string(Source['TenantId']);
end;


procedure TOrganisationConfiguration.Assign(Source: JS.TJSObject);
var
  lValue: JSValue;
  lStrValue: string;
begin
  ClearDownSubmission := boolean(Source['ClearDownSubmission']);
  NoMatching := boolean(Source['NoMatching']);
  SaveHMRCPassword := boolean(Source['SaveHMRCPassword']);
  if TJSObject(Source).HasOwnProperty('HMRCPromptShown') then
  begin
    lValue := Source['HMRCPromptShown'];
    // Handle both boolean and string values robustly
    // In Pas2JS, JSON booleans come through as actual booleans, but handle strings too
    if JS.isBoolean(lValue) then
      HMRCPromptShown := JS.toBoolean(lValue)
    else
    begin
      // If it's a string, check for "true" (case-insensitive)
      lStrValue := string(lValue);
      HMRCPromptShown := (lStrValue.ToLower = 'true');
    end;
  end
  else
    HMRCPromptShown := False;
  // MaxClaimAmount is loaded from CHARITY via GetClaimMaxAmountSettings, not org config JSON.
  MaxClaimAmount := 0;
end;

procedure TClaimMaxAmountSettings.Assign(Source: JS.TJSObject);
begin
  Enabled := boolean(Source['Enabled']);
  if Assigned(Source) and Source.hasOwnProperty('ServerAmount') and (Source['ServerAmount'] <> nil) then
    ServerAmount := Double(Source['ServerAmount'])
  else
    ServerAmount := 0;
  if Assigned(Source) and Source.hasOwnProperty('CharityAmount') and (Source['CharityAmount'] <> nil) then
    CharityAmount := Double(Source['CharityAmount'])
  else
    CharityAmount := 0;
end;

procedure TClaimDeclarationPersistResult.Assign(Source: JS.TJSObject);

  function ParseJsDate(const AValue: JSValue): TDateTime;
  var
    lMs: Double;
  begin
    Result := 0;
    if not Assigned(AValue) then
      Exit;
    lMs := 0;
    asm
      var v = AValue;
      var d = (v instanceof Date) ? v : new Date(v);
      if (!isNaN(d.getTime())) {
        lMs = d.getTime();
      }
    end;
    if lMs > 0 then
      { JS ms since 1970-01-01 → Delphi TDateTime (days since 1899-12-30). }
      Result := (lMs / 86400000) + 25569;
  end;

begin
  Success := boolean(Source['Success']);
  DeclarationId := Integer(Source['DeclarationId']);
  if Assigned(Source['ClaimId']) then
    ClaimId := Integer(Source['ClaimId'])
  else
    ClaimId := 0;
  DeclarationStatus := string(Source['DeclarationStatus']);
  SignedByUser := Integer(Source['SignedByUser']);
  SignedByName := string(Source['SignedByName']);
  SigningChannel := string(Source['SigningChannel']);
  SignedAt := ParseJsDate(Source['SignedAt']);
  ExpiresAt := ParseJsDate(Source['ExpiresAt']);
  Message := string(Source['Message']);
end;


procedure TPrepareClaimData.Assign(Source: JS.TJSObject);
begin
  Complete := boolean(Source['Complete']);
  ClaimId := integer(Source['ClaimId']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
  LimitExceeded := boolean(Source['LimitExceeded']);
  MaxClaimCount := integer(Source['MaxClaimCount']);
  MaxClaimAmount := currency(Source['MaxClaimAmount']);
  IncludedDonationCount := integer(Source['IncludedDonationCount']);
  IncludedAmount := currency(Source['IncludedAmount']);
  IncludedGiftAid := currency(Source['IncludedGiftAid']);
  RemainingDonationCount := integer(Source['RemainingDonationCount']);
  RemainingAmount := currency(Source['RemainingAmount']);
  RemainingGiftAid := currency(Source['RemainingGiftAid']);
  EligibleGiftAid := currency(Source['EligibleGiftAid']);
  NothingFitsLimit := boolean(Source['NothingFitsLimit']);
end;

procedure TClaimParameters.Assign(Source: JS.TJSObject);
begin
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportIds := string(Source['ImportIds']);
  ImportFiles := string(Source['ImportFiles']);
end;

procedure TResumableClaimInfo.Assign(Source: JS.TJSObject);

  function ParseJsDate(const AValue: JSValue): TDateTime;
  var
    lMs: Double;
  begin
    Result := 0;
    if not Assigned(AValue) then
      Exit;
    lMs := 0;
    asm
      var v = AValue;
      var d = (v instanceof Date) ? v : new Date(v);
      if (!isNaN(d.getTime())) {
        lMs = d.getTime();
      }
    end;
    if lMs > 0 then
      Result := (lMs / 86400000) + 25569;
  end;

begin
  Exists := boolean(Source['Exists']);
  ClaimId := integer(Source['ClaimId']);
  ClaimRef := string(Source['ClaimRef']);
  ClaimStatus := string(Source['ClaimStatus']);
  DeclarationSigned := boolean(Source['DeclarationSigned']);
  DeclarationExpiresAt := ParseJsDate(Source['DeclarationExpiresAt']);
end;

procedure TRetrievePreparedClaim.Assign(Source: JS.TJSObject);
begin
  Exists := boolean(Source['Exists']);
  PrepareJobId := integer(Source['PrepareJobId']);
  ClaimId := integer(Source['ClaimId']);
  OldestDate := string(Source['OldestDate']);
  NewestDate := string(Source['NewestDate']);
  ImportId := string(Source['ImportId']);
  ClaimRef := string(Source['ClaimRef']);
  DonationCount := integer(Source['DonationCount']);
  Amount := currency(Source['Amount']);
  GiftAid := currency(Source['GiftAid']);
  GASDS := currency(Source['GASDS']);
  AggregatedDonations := currency(Source['AggregatedDonations']);
  OtherIncome := currency(Source['OtherIncome']);
  GASDSAdjustments := currency(Source['GASDSAdjustments']);
  Adjustments := currency(Source['Adjustments']);
  CommunityBuildings := currency(Source['CommunityBuildings']);
end;

{$ENDIF}


end.
